<template>
  <div class="my-account">
    <p class="tips">
      <i class="el-icon-info"></i>
      <span>只有团队队长才能进行账号的管理操作</span>
    </p>
    <el-table :data="list" stripe class="list">
      <el-table-column prop="episode" label="集数" width="80" align="center">
      </el-table-column>
      <el-table-column prop="title" label="文案标题"> </el-table-column>
      <el-table-column label="后期视频" width="100" align="center">
        <template slot-scope="{ row }">
          <el-button
            size="mini"
            type="text"
            @click="
              showVideo = true;
              videoUrl = row.productionVideo;
            "
            >播放</el-button
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="上传时间"
        width="180"
        align="center"
      >
      </el-table-column>
      <!-- <el-table-column label="DOU+投放" align="center">
        <template slot-scope="{ row }">
          <div class="item">
            <span>投放目标: </span>
            <el-select
              v-model="row.target"
              size="mini"
              placeholder="请选择投放目标"
            >
              <el-option
                v-for="item in targetList"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
          <div class="item">
            <span>投放时间: </span>
            <el-select
              v-model="row.during"
              size="mini"
              placeholder="请选择投放时间"
            >
              <el-option
                v-for="item in duringList"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
          <div class="item">
            <span>投放方式: </span>
            <el-select
              v-model="row.mode"
              size="mini"
              placeholder="请选择投放方式"
            >
              <el-option
                v-for="item in modeList"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
          <div class="item">
            <span>投放金额: </span>
            <el-input-number
              v-model="row.amount"
              :min="0"
              size="mini"
            ></el-input-number>
          </div>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="douyinVideoStatus"
        label="视频状态"
        width="100"
        align="center"
      >
        <template slot-scope="{ row }">
          <el-tag type="info" size="small" v-if="row.douyinVideoStatus == 0"
            >未上传</el-tag
          >
          <el-tag size="small" v-if="row.douyinVideoStatus == 1">上传中</el-tag>
          <el-tag type="success" size="small" v-if="row.douyinVideoStatus == 2"
            >已上传</el-tag
          >
          <el-tag type="danger" size="small" v-if="row.douyinVideoStatus == -1"
            >上传失败</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center">
        <template slot-scope="{ row }">
          <el-button
            v-if="isCaptain"
            size="mini"
            type="text"
            @click="handleUpload(row.waId)"
            >上传至抖音</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      class="video-dialog"
      :visible.sync="showVideo"
      width="40%"
      :close-on-click-modal="false"
    >
      <video
        v-if="showVideo"
        style="width: 100%; max-height: 55vh"
        :src="videoUrl"
        controls
      ></video>
    </el-dialog>

    <el-dialog
      :visible.sync="show"
      title="视频标题"
      width="35%"
      center
      :close-on-click-modal="false"
    >
      <el-input
        v-model="params.title"
        size="small"
        placeholder="请输入视频标题"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="show = false">取 消</el-button>
        <el-button type="primary" size="small" @click="handleUploadDy"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  operationList,
  uploadDy,
} from "@/api/projectPractice/accountOperation";
export default {
  data() {
    return {
      isCaptain: false,
      list: [],
      showVideo: false,
      videoUrl: "",
      targetList: [
        "评论链接点击",
        "智能优化",
        "线索量",
        "主页浏览量",
        "点赞评论量",
        "粉丝量",
      ],
      modeList: ["系统智能推荐", "自定义定向推荐"],
      show: false,
      params: {
        waId: null,
        title: "",
      },
    };
  },
  created() {
    this.getList();
  },
  computed: {
    duringList() {
      let hourArr = ["2小时", "6小时", "12小时", "24小时"];
      let arr = [];
      for (let i = 2; i <= 30; i++) {
        arr.push(`${i}天`);
      }
      return [...hourArr, ...arr];
    },
  },
  watch: {
    show(val) {
      if (!val) this.params = this.$options.data().params;
    },
  },
  methods: {
    // 列表
    getList() {
      this.$loading.show();
      operationList({ classId: this.$route.query.id }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.list = res.data.list;
          this.isCaptain = res.data.isCaptain;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleUpload(waId) {
      this.show = true;
      this.params.waId = waId;
    },
    handleUploadDy() {
      this.$confirm("确定要将视频上传到绑定的抖音号吗?", {
        type: "warning",
      })
        .then(() => {
          this.$loading.show();
          uploadDy(this.params).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.show = false;
              this.getList();
              this.$message.success("系统正在进行上传操作");
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.my-account {
  .tips {
    margin-bottom: 10px;
    text-align: left;
    color: #f56c6c;
    i {
      margin-right: 5px;
    }
  }
  ::v-deep .list {
    .is-leaf {
      color: #333;
      background-color: #f5f5f5;
    }
    .item {
      margin-bottom: 10px;
    }
  }
}
</style>